import { render } from "./rootFrameworks.vue?vue&type=template&id=2fcde1fc&scoped=true&ts=true"
import script from "./rootFrameworks.vue?vue&type=script&lang=ts"
export * from "./rootFrameworks.vue?vue&type=script&lang=ts"

import "./rootFrameworks.vue?vue&type=style&index=0&id=2fcde1fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcde1fc"]])

export default __exports__